import React, { useState } from 'react';
import './LegalPages.css';

function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Redirect to subscription page
    window.location.href = '/lp/xbt1l';
  };

  return (
    <div className="legal-page">
      <div className="legal-header">
        <div className="legal-header-content">
          <h1>Sign In to DocuAIHub</h1>
          <p>Access your account and manage your documents</p>
        </div>
      </div>

      <div className="legal-container">
        <div className="legal-content">
          <section className="content-section">
            <div style={{ maxWidth: '500px', margin: '0 auto' }}>
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div>
                  <label 
                    htmlFor="email" 
                    style={{ 
                      display: 'block', 
                      marginBottom: '8px', 
                      fontWeight: '600',
                      color: '#2d3748'
                    }}
                  >
                    Email Address
                  </label>
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    required
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      fontSize: '16px',
                      border: '2px solid #e2e8f0',
                      borderRadius: '8px',
                      outline: 'none',
                      transition: 'border-color 0.2s',
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>

                <div>
                  <label 
                    htmlFor="password" 
                    style={{ 
                      display: 'block', 
                      marginBottom: '8px', 
                      fontWeight: '600',
                      color: '#2d3748'
                    }}
                  >
                    Password
                  </label>
                  <input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    required
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      fontSize: '16px',
                      border: '2px solid #e2e8f0',
                      borderRadius: '8px',
                      outline: 'none',
                      transition: 'border-color 0.2s',
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                    <input type="checkbox" style={{ cursor: 'pointer' }} />
                    <span style={{ fontSize: '14px', color: '#4a5568' }}>Remember me</span>
                  </label>
                  <a 
                    href="/lp/xbt1l" 
                    style={{ 
                      fontSize: '14px', 
                      color: '#667eea', 
                      textDecoration: 'none',
                      fontWeight: '500'
                    }}
                  >
                    Forgot password?
                  </a>
                </div>

                <button
                  type="submit"
                  style={{
                    width: '100%',
                    padding: '14px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'transform 0.2s',
                    marginTop: '10px'
                  }}
                  onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                  onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                >
                  Sign In
                </button>
              </form>

              <div style={{ marginTop: '30px', textAlign: 'center' }}>
                <p style={{ color: '#718096', marginBottom: '15px' }}>Don't have an account?</p>
                <a 
                  href="/lp/xbt1l" 
                  style={{
                    display: 'inline-block',
                    padding: '12px 30px',
                    background: 'transparent',
                    color: '#667eea',
                    border: '2px solid #667eea',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    fontWeight: '600',
                    transition: 'all 0.2s',
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background = '#667eea';
                    e.target.style.color = 'white';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = 'transparent';
                    e.target.style.color = '#667eea';
                  }}
                >
                  Create Account
                </a>
              </div>
            </div>
          </section>

          <section className="content-section" style={{ marginTop: '60px' }}>
            <h2>Why Sign In to DocuAIHub?</h2>
            <ul>
              <li>Access your document history and downloads</li>
              <li>Save time with document templates</li>
              <li>Manage your subscription and billing</li>
              <li>Sync across multiple devices</li>
              <li>Priority customer support</li>
              <li>Advanced AI features for subscribers</li>
            </ul>
          </section>

          <section className="content-section">
            <h2>Secure & Private</h2>
            <p>
              Your security is our top priority. We use industry-standard encryption to protect 
              your data and never share your information with third parties. All documents are 
              automatically deleted after processing.
            </p>
          </section>

          <section className="content-section">
            <h2>Need Help?</h2>
            <p>
              If you're having trouble signing in or have questions about your account, 
              our support team is ready to assist you.
            </p>
            <p>
              <strong>Email:</strong> help@docuaihub.com<br />
              <strong>Phone:</strong> +357 77788373
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
